module.exports = __webpack_public_path__ + "static/img/9.7bcfa25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/2/sp/9.png
// module id = jiBK
// module chunks = 0